import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BlockUIModule } from 'ng-block-ui';
import { NotifierModule } from 'angular-notifier';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GoogleMapsModule } from '@angular/google-maps';
import { MbscModule, MbscOptionsService } from '@mobiscroll/angular';
import { Router } from '@angular/router';
import { provideEnvironmentNgxMask } from 'ngx-mask'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoggingInterceptor } from './core/services/ajax-call.service';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        BlockUIModule.forRoot(),
        NotifierModule.withConfig({
            position: {
                horizontal: {
                    position: 'middle'
                },
                vertical: {
                    position: 'top',
                    distance: 50
                }
            },
            behaviour: {
                autoHide: 3000,
                showDismissButton: false,
            }
        }),
        CoreModule,
        FormsModule,
        FontAwesomeModule,
        AppRoutingModule,
        GoogleMapsModule,
        MbscModule,
        NgxSliderModule,
    ],
    providers: [
        DatePipe,
        MbscOptionsService,
        provideEnvironmentNgxMask(),
        { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(
        private readonly router: Router,
    ) {
        //router.events.subscribe(console.log);
    }

}
